/**
 * Convierte valores de API (Decimal/string/number) a número positivo o null.
 */
export function parsePositiveMoney(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') {
    return Number.isFinite(value) && value > 0 ? value : null;
  }
  const s = String(value).replace(/,/g, '').trim();
  if (!s || s === '0') return null;
  const n = parseFloat(s);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** Moneda mexicana: $12,345.67 MXN (locale es-MX) */
export function formatCurrencyMxn(amount: number): string {
  return amount.toLocaleString('es-MX', {
    style: 'currency',
    currency: 'MXN',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

/**
 * Extrae renta mensual del texto admin ("Monto: $…") o de JSON si existiera el campo.
 */
export function extractMonthlyRentFromApplicationNotes(notes?: string | null): number | null {
  if (!notes || typeof notes !== 'string' || notes.trim() === '') return null;

  const legacy = notes.match(/\$([\d,]+(?:\.\d{1,2})?)/);
  if (legacy) {
    const n = parseFloat(legacy[1].replace(/,/g, ''));
    if (Number.isFinite(n) && n > 0) return n;
  }

  const montoLabel = notes.match(/Monto\s*:\s*\$?\s*([\d,]+(?:\.\d{1,2})?)/i);
  if (montoLabel) {
    const n = parseFloat(montoLabel[1].replace(/,/g, ''));
    if (Number.isFinite(n) && n > 0) return n;
  }

  try {
    const j = JSON.parse(notes) as Record<string, unknown>;
    if (j && typeof j === 'object') {
      const v =
        j.monthlyRent ??
        (j.datosFormulario as Record<string, unknown> | undefined)?.costoRenta ??
        (j.datosFormulario as Record<string, unknown> | undefined)?.rentaMensual;
      return parsePositiveMoney(v);
    }
  } catch {
    // no es JSON
  }

  return null;
}

/**
 * Prioridad: unidad (BD) → notas de la solicitud (texto admin o JSON).
 */
export function resolveMonthlyRentForDisplay(
  unit: { monthlyRent?: unknown } | null | undefined,
  applicationNotes?: string | null,
): number | null {
  const fromUnit = unit ? parsePositiveMoney(unit.monthlyRent) : null;
  if (fromUnit != null) return fromUnit;
  return extractMonthlyRentFromApplicationNotes(applicationNotes ?? undefined);
}
